export default __webpack_public_path__ + "static/media/ErrorInCont.2965043c.mp4";